{
  "saveSuccess": "Zmiany zapisano pomyślnie"
}
